import { getProductsFromQuery } from './useProductsData';
import { DocumentNode } from 'graphql';
import {
    BrandProductsQueryApi,
    BrandProductsQueryVariablesApi,
    CategoryProductsQueryApi,
    CategoryProductsQueryVariablesApi,
    FlagProductsQueryApi,
    FlagProductsQueryVariablesApi,
    ListedProductConnectionFragmentApi,
    Maybe,
    ProductFilterApi,
    ProductOrderingModeEnumApi,
} from 'graphql/generated';
import { Client } from 'urql';

export const readProductsFromCache = (
    queryDocument: DocumentNode,
    client: Client,
    urlSlug: string,
    orderingMode: ProductOrderingModeEnumApi | null,
    filter: Maybe<ProductFilterApi>,
    endCursor: string,
    pageSize: number,
): {
    products: ListedProductConnectionFragmentApi['edges'] | undefined;
    hasNextPage: boolean;
} => {
    const dataFromCache = client.readQuery<
        CategoryProductsQueryApi | BrandProductsQueryApi | FlagProductsQueryApi,
        CategoryProductsQueryVariablesApi | BrandProductsQueryVariablesApi | FlagProductsQueryVariablesApi
    >(queryDocument, {
        urlSlug,
        orderingMode,
        filter,
        endCursor,
        first: pageSize,
    })?.data;

    const productData = getProductsFromQuery(dataFromCache);

    return {
        products: productData?.edges,
        hasNextPage: !!productData?.pageInfo.hasNextPage,
    };
};
